<template lang="pug">
div
  v-progress-circular(
    v-if="loading",
    indeterminate,
    color="primary",
    :size="20",
    :width="2"
  )
  .caption.font-weight-bold.secondary--text.mr-6(v-else) Rp. {{ balance | decimalformat }}
</template>
<script>
export default {
  name: "FAccountBalanceContent",
  props: ["account"],
  data() {
    return {
      accountNumber: "",
      loading: false,
      balance: 0.0,
    };
  },
  mounted() {
    this.accountNumber = this.account ? this.account : "";
    this.doLoadBalance();
  },
  methods: {
    doLoadBalance() {
      if (this.accountNumber) {
        this.loading = true;
        this.$http
          .get("api/banking/balance-account", {
            params: { accountNumber: this.accountNumber },
          })
          .then(
            (success) => {
              this.balance = success.data.lastBalance;
            },
            (err) => {
              this.balance = 0.0;
            }
          )
          .finally(() => (this.loading = false));
      }
    },
  },
};
</script>